import { FETCH_WP_CONTENT_RESULT } from "../actions/index";

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_WP_CONTENT_RESULT:
      return { ...state, content: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/WP.js